import React, { useContext, useState } from 'react';
import STC from '../../../../../../../../../STCLibrary/STCFactory/STCFactory';
import './PassportForm.css';
import DropDown from '../../../../../../../../../STCLibrary/DropDown/DropDown';
import { PassengerAPI } from '../../../../../../../../../API/PassengerAPIs/PassengerAPIs';
import { FaQuestionCircle } from "react-icons/fa";
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import NotificationContext from '../../../../../../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';

export default function PassportForm({passenger, handleSavedPassport}){

    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [docType, setDocType] = useState(passenger.passport?.idDocType ?? '');
    const [docNum, setDocNum] = useState(passenger.passport?.docNumber ?? '');
    const [countryIssued, setCountryIssued] = useState(passenger.passport?.countryOfIssue.code ?? '');
    const [nationality, setNationality] = useState(passenger.passport?.nationality.code ?? '');
    const [expiryDate, setExpiryDate] = useState(passenger.passport?.expiryDate ?? '');
    const [biometric, setBiometric] = useState(passenger.passport?.isBiometric ?? true);

    const [sending, setSending] = useState(false);
    const [errorLoading, setErrorLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [bioInfo, setBioInfo] = useState(false);

    const handleSubmit = (e) => {
        e.stopPropagation();
        e.preventDefault();

        setSending(true);
        setErrorLoading(false);

        const passportDetails = {
            docNumber: docNum,
            expiryDate: expiryDate,
            idDocType: docType,
            isBiometric: biometric,
            countryOfIssue: {
                code: countryIssued,
                name: "",
                iso3Code: "",
                isoName: ""
            },
            nationality: {
                code: nationality,
                name: "",
                iso3Code: "",
                isoName: ""
            }
        }

        // if(format(new Date(expiryDate), 'T') < (parseInt(format(new Date(), 'T')) + 15778476000)){
        if(format(new Date(expiryDate), 'T') < (parseInt(format(new Date(), 'T')))){
            setSending(false);
            // setErrorMsg('Please review the passport expiry date. Passport must not expire within the next 6 months.');
            setErrorMsg('Please review the passport expiry date. Passport entered is expired.');
            setErrorLoading(true);
            return
        }

        PassengerAPI.PostPassengerPassport(passenger.id, passportDetails)
        .then((response) => {
            if(response.status === 200){
                setSending(false);
                handleSavedPassport();
                ApiResponseHandler(response, notificationCtx, navigate);
            }
            
        })
        .catch((err) => {
            console.log(err);
            setSending(false);
            setErrorMsg('There was a error saving your passport details. Please try again later');
            setErrorLoading(true);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
    }

    const handleClear = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setDocType('');
        setDocNum('');
        setCountryIssued('');
        setNationality('');
        setExpiryDate('');
        setBiometric(false);
    }

    return(
        <div>

            <STC.Alert className="m-2" variant={"warning"}>
                Passport details must be provided 6 weeks before the tour date or airline airport check-in fees starting from €65 may apply. Flights will be booked based on the passport information first provided. Changes are recorded and could incur a name change fee of minimum €115.
            </STC.Alert>
            
        <STC.Form onSubmit={handleSubmit} onReset={handleClear}>

        <div className="m-1">
            <STC.Form.Label htmlFor='doc-type-select'>Document Type</STC.Form.Label>
            <STC.Form.Select
              id='doc-type-select'
              required
            //   size='sm'
              disabled={sending}
              value={docType}
              onChange={(e) => setDocType(e.target.value)}
            >   
              <option  value=''>Document Type</option>    
              <option className='option' value='PASSPORT'>Passport</option>    
              <option className='option' value='EEA_NATIONAL_ID_CARD'>EEA National ID Card</option>    
            </STC.Form.Select>
            </div>

            <STC.Form.Group className="m-1">
                
                <STC.Form.FloatingLabel>
                    <STC.Form.Control
                        id="doc-num-input"
                        placeholder={"Document Number"}
                        required
                        value={docNum}
                        disabled={sending}
                        onChange={(e) => setDocNum(e.target.value) }
                        />
                    <label style={{marginLeft: '0.5rem'}} htmlFor="doc-num-input">Document Number</label>
                </STC.Form.FloatingLabel>

            </STC.Form.Group>
            
              <STC.Form.Group className="m-1">
                <div>
                <label>Country of Issue</label>
                </div>
                
                <DropDown.Country
                    required
                    // size='sm'
                    disabled={sending}
                    value={countryIssued}
                    onChange={(e) => setCountryIssued(e.target.value)}
                />
            </STC.Form.Group>

            <STC.Form.Group className="m-1">
                <STC.Form.Label>Nationality</STC.Form.Label>
                <DropDown.Country
                    required
                    // size='sm'
                    disabled={sending}
                    value={nationality}
                    onChange={(e) => setNationality(e.target.value)}
                />
            </STC.Form.Group>

            <STC.Form.Group className="m-1">
                <STC.Form.Label htmlFor='expiry-input'>Expiry Date</STC.Form.Label>
                <STC.Form.Control 
                    id='expiry-input'
                    type='date'
                    // size='sm'
                    required
                    disabled={sending}
                    value={expiryDate}
                    onChange={(e) => setExpiryDate(e.target.value)}
                />
            </STC.Form.Group>

            <STC.Form.Group className='mb-1'>
                <div className='biometric-label-line'>
                    <STC.Form.Label htmlFor='bio-input'>Biometric</STC.Form.Label>
                    <div align={'end'} className='info-icon' onClick={()=>setBioInfo(!bioInfo)}>More Info <FaQuestionCircle/></div>
                </div>
                
                {/* <STC.Form.Check id='bio-input' className='check' 
                    // size='sm'
                    required
                    disabled={sending}
                    checked={biometric}
                    onChange={(e) => setBiometric(!biometric)}
                /> */}
                <div>
                {/* <label className="passport-switch">
                    <input 
                        id='bio-input'
                        disabled={sending}
                        checked={biometric}
                        onChange={(e) => setBiometric(!biometric)}
                        type="checkbox"
                    />
                    <span className="passport-slider round"></span>
                </label> */}
            </div>

            </STC.Form.Group>

            
            
            {bioInfo &&
            <STC.Alert>
                <div className='biometric-info-line'>
                    <div>
                        A biometric passport (also known as an electronic passport, e-passport or a digital passport) is a traditional passport that has an embedded electronic microprocessor chip, which contains biometric information that can be used to authenticate the identity of the passport holder.
                        This biometric symbol is usually printed on the cover of biometric (ICAO compliant) passports. Please tick the box if your passport has this symbol.
                    </div>
                    <div className='image-div'>
                        <img 
                            src={'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/EPassport_logo.svg/1280px-EPassport_logo.svg.png'} 
                            alt={'BioLogo'} 
                        />
                    </div>
                </div>
            </STC.Alert>
            }

            {errorLoading &&
            <STC.Alert variant='danger'>{errorMsg}</STC.Alert>}

            

            <STC.Button disabled={sending} size='sm' type='submit' style={{ marginTop: '10px' }}>Submit</STC.Button>
            {/* <STC.Button disabled={sending} size='sm' type='reset'  style={{ marginLeft: '15px',marginTop: '10px' }}>Clear</STC.Button> */}
            
        </STC.Form>
        </div>
    )
}